<template>
    <div class="cat_conter" :id="'option'+idx">
        <div class="conter_top">
            <div class="testpaper-question-tit-wrap">
                <div class="testpaper-question-tit">{{idx+1}}</div>
                <div class="testpaper-question-score">{{parentData.topic_score}}.0分</div>
            </div>
            <div class="testpaper-question-topic clearfix">
                <div v-html="strcharacterDiscode(parentData.topic_stem)"></div>
                <!-- <div domPropsInnerHTML={parentData.topic_stem}></div> -->
                <!-- <p v-html="dt"></p> -->
                <br />
            </div>
        </div>
        <ul class="testpaper-question-choices" v-for='(sub_item,sub_key) in parentData.topic_metas' :key="sub_key">
            <li @click="singleData(sub_key,parentData.topic_id,idx)">
                <span :class = '{active:isactive==sub_key}' class="testpaper-question-choice-index" >{{option[sub_key]}}</span>
                <p v-html="strcharacterDiscode(sub_item)"></p>
            </li>
        </ul>
    </div>
</template>

<script>
    import strcharacterDiscode from '@/js/strcharacterDiscode'
    export default {
        props:['parentData','idx'],
        data(){
            return {
                option: ['A','B','C','D','E','F','G','H','I','J'],
                isactive : -1,
                selectIndex: []
            }
        },
        created() {
            // console.log(this.radio2)
            // console.log(this.parentData,222222);
            // this.parentData.topic_stem=`${this.parentData.topic_stem}`;
        },
        methods: {
            singleData(index,key,idx) {
                // let arr = [];
                // if(arr.indexOf(index) > 0) {
                //     arr.splice(index,1)
                // }else {
                //     arr.push(index);
                // }
                var allEle=document.querySelectorAll(".el-card__header");
                // console.log(allEle,88888)
                this.isactive=index;
                this.$emit('singleData',[index,key])
                if(this.isactive!=-1){
                     document.querySelector("#card"+idx).className="active";
                }
                let returnEle = document.querySelector("#option"+(idx+1));
                // !!returnEle && returnEle.scrollIntoView(true);
                if(!!returnEle){
                    document.documentElement.scrollTop = (returnEle.offsetTop - allEle[0].clientHeight)
                }
                
                // console.log(index,1111)
                
            },
            strcharacterDiscode
        }
    }
</script>

<style scoped>
    .testpaper-question-tit-wrap{
        float: left;
        margin-right: 10px;
        text-align: center;
    }
    .testpaper-question-tit{
        font-size: 20px;
        color: #3a87ad;
    }
    .testpaper-question-score {
        font-size: 12px;
        color: #aaa;
        border: 1px solid #ccc;
        padding: 0 1px;
        border-radius: 5px;
        background: #f6f6f6;
        display: inline-block;
    }
    .testpaper-question-topic {
        border-bottom: 1px dashed #ddd;
        margin-bottom: 10px;
        overflow: hidden;
        zoom: 1;
    }
    .active{
        background: rgb(105, 153, 117) !important;
        color: #fff !important;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/SingleChoice.vue